export default {
  color: [
    "#4576B5",
    "#B84644",
    "#91B24F",
    "#745998",
    "#42A2BF",
    "#749f83",
    "#ca8622",
    "#bda29a",
    "#6e7074",
    "#546570",
    "#c4ccd3",
  ],
};
